import { memo } from "react";
import { cn } from "@discovery/classnames";
import { SonicImage, } from "@discovery/components-luna/lib/components/atoms/image";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { useEffect, useState, useRef, useGlobalState, } from "@discovery/common-dplus/lib/hooks";
import * as M from "@discovery/prelude/lib/data/maybe";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { getIsMobile } from "../../../../../utils/isMobile";
import { shareHandler, SHARE_TYPE } from "../../../../../utils/share";
import { Icon, Icons } from "../../../../atoms/icon";
import { Link } from "../../../../atoms/link";
import { PlaceholderImage } from "../../../../atoms/placeholder-image";
import { ProgressBar } from "../../../../atoms/progress-bar";
import { HeaderVariants, Tags, Typography } from "../../../../atoms/typography";
import { KebabMenuContinueWatch } from "../../../kebab-menu-continue-watch";
import { parseMillisecondsIntoReadableHours, parseMillisecondsIntoReadableMin, } from "../../../../../utils/date";
import { RailTypes } from "../../../../../component-creators/rails";
import * as styles from "./styles.css";
import { SonicImageDplus } from "../../../../atoms/sonic-image";
import { KebabMenuForUnFavorites } from "../../../../../components/molecules/kebabMenuForLikeWatchLater";
import Strings from "../../../../../utils/hardcoded.json";
import OverlayD from "./_components/overlayD";
import { useUser, useWindowSize } from "../../../../../utils/hooks";
import { _user } from "@discovery/common-dplus/lib/state";
const IMAGE_SIZE = {
    default: [327, "px"],
};
const FALL_BACK_IMAGE_SIZE = {
    width: 327,
};
export const BasicCard = memo(({ webAuthRedirectionUrl, railType, ageConstraint = 0, minimumAgeM = M.empty(), isFavoriteM = M.empty(), id, descriptionM = M.empty(), name, route, durationM = M.empty(), viewingHistoryM = M.empty(), image, packages, isPlayable = false, category = "", seasonNumberM = M.empty(), isNewEpisodeM = M.empty(), removeFromContinueWatch, videoType = M.empty(), isViewAll = false, showKebabMenu = false, read, isFavPage, removeFromfavorites, genre = M.empty(), shouldOpenInNewWindow, isSearchPage, contentGenre, }) => {
    const [width] = useWindowSize();
    const [userM] = useGlobalState(_user);
    const [isContentAccessible, setisContentAccessible] = useState(false);
    const isFav = M.fromMaybe(isFavoriteM, false);
    const [isFavorite, setisFavorite] = useState(isFav);
    const { premiumPackagesM, isAnonymous } = useUser();
    const premiumPackages = M.fromMaybe(premiumPackagesM, []);
    const vtype = M.fromMaybe(videoType, "");
    const seasonId = M.fromMaybe(seasonNumberM, 0);
    const sId = seasonId > 0 ? `&seasonId=${seasonId}` : "";
    const vType = vtype ? `?type=${vtype}` : "";
    const linkHref = route + `${vType}${sId}`;
    const shareURL = config.shareBaseURL + route;
    const isPremium = premiumPackages.includes(packages);
    const userDetails = {
        idM: M.map((user) => user.id, userM),
    };
    const userId = M.fromMaybe(userDetails.idM, "");
    useEffect(() => {
        const isFavorite = M.fromMaybe(isFavoriteM, false);
        const minimumAge = M.fromMaybe(minimumAgeM, 0);
        const isContentAccessible = minimumAge >= ageConstraint;
        setisContentAccessible(isContentAccessible);
        setisFavorite(isFavorite);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const kebabHandlerContinueWatch = (label, description, title, id, image) => {
        switch (label) {
            case "Remove":
            case "Remove from Continue Watching":
                return removeFromContinueWatch && id && removeFromContinueWatch(id);
            case "Share":
                return shareHandler(SHARE_TYPE.SHARE, image, description, title, shareURL);
        }
    };
    return (React.createElement("div", { className: styles.gridTemplate, id: `#cards${id}` }, width && width <= 699 ? (React.createElement(BasicCardMobile, { isContentAccessible: isContentAccessible, id: id, railType: railType, name: name, descriptionM: descriptionM, route: route, seasonNumberM: seasonNumberM, isFavorite: isFavorite, durationM: durationM, isPlayable: isPlayable, category: category, image: image, isNewEpisodeM: isNewEpisodeM, packages: packages, isPremium: isPremium, videoType: videoType, viewingHistoryM: viewingHistoryM, linkHref: linkHref, isViewAll: isViewAll, kebabHandlerContinueWatch: kebabHandlerContinueWatch, removeFromfavorites: removeFromfavorites, showKebabMenu: showKebabMenu, anonymous: isAnonymous, webAuthRedirectionUrl: webAuthRedirectionUrl, read: read, genre: genre, isSearchPage: isSearchPage, userId: userId })) : (React.createElement(BasicDeskTopCard, { isContentAccessible: isContentAccessible, id: id, name: name, railType: railType, descriptionM: descriptionM, route: route, seasonNumberM: seasonNumberM, isFavorite: isFavorite, durationM: durationM, isPlayable: isPlayable, category: category, image: image, isNewEpisodeM: isNewEpisodeM, packages: packages, videoType: videoType, viewingHistoryM: viewingHistoryM, linkHref: linkHref, isPremium: isPremium, kebabHandlerContinueWatch: kebabHandlerContinueWatch, webAuthRedirectionUrl: webAuthRedirectionUrl, read: read, isFavPage: isFavPage, removeFromfavorites: removeFromfavorites, genre: genre, shouldOpenInNewWindow: shouldOpenInNewWindow, userId: userId, contentGenre: contentGenre }))));
});
const BasicDeskTopCard = ({ id, railType, descriptionM, name, route, isFavorite, durationM, viewingHistoryM, isPlayable, category = "", image, isNewEpisodeM, isContentAccessible, isPremium, linkHref, kebabHandlerContinueWatch, webAuthRedirectionUrl, read, isFavPage, removeFromfavorites, genre, shouldOpenInNewWindow, contentGenre, }) => {
    const KebabMenuItems = [
        {
            label: Strings.REMOVE,
            name: name,
            description: descriptionM,
            route: route,
            id: id,
        },
    ];
    const hours = parseMillisecondsIntoReadableHours(durationM, viewingHistoryM);
    const mins = parseMillisecondsIntoReadableMin(durationM, viewingHistoryM);
    return (React.createElement("div", { id: `${id}`, className: cn(styles.thumbnailContainer, {
            [styles.hoverable]: !getIsMobile(),
        }) },
        React.createElement(OverlayD, { railType: railType, descriptionM: descriptionM, kebabMenuItems: KebabMenuItems, isFavorite: isFavorite, read: read, category: category, id: id, webAuthRedirectionUrl: webAuthRedirectionUrl, isFavPage: isFavPage, linkHref: linkHref, kebabHandlerContinueWatch: kebabHandlerContinueWatch, removeFromfavorites: removeFromfavorites, route: route, showGenre: genre, name: name, shouldOpenInNewWindow: shouldOpenInNewWindow, contentGenre: contentGenre }),
        React.createElement(Link, { href: linkHref },
            React.createElement("div", { className: cn(styles.thumbnailImageContainer, {
                    [styles.descriptiveThumbnailContainer]: railType === RailTypes.DescriptiveWithProgress,
                }) },
                React.createElement("div", { className: styles.thumbnailImageWrapper },
                    isPremium && (React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: styles.premiumIcon })),
                    isContentAccessible && (React.createElement(Icon, { type: Icons.Plus18Tag, className: styles.ageConstraints })),
                    React.createElement(PlaceholderImage, null),
                    React.createElement(SonicImage, { image: image, quality: 75, imageSizes: IMAGE_SIZE, fallbackImageSize: FALL_BACK_IMAGE_SIZE, className: styles.thumbnailImage }),
                    railType !== RailTypes.DescriptiveWithProgress && (React.createElement(RenderMaybe, null, M.map((isNewEpisode) => {
                        return (React.createElement("div", { className: styles.newEpisodeContainer }, isNewEpisode && (React.createElement("span", { className: styles.Episodes }, Strings.NEW_EPISODES))));
                    }, isNewEpisodeM))),
                    isPlayable === true && (React.createElement("div", { className: styles.PlayIcon },
                        React.createElement(Icon, { type: Icons.PlayIcon, className: styles.playIcon }))),
                    railType === RailTypes.DescriptiveWithProgress && (React.createElement("div", { className: styles.DescriptiveHeading },
                        React.createElement(Typography, { variant: HeaderVariants.headingSix, tag: Tags.h6, classNameM: M.of(styles.basicShowName) },
                            React.createElement(React.Fragment, null, name)))),
                    railType === RailTypes.DescriptiveWithProgress && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.timeRemaining, id: "timeRemaining" },
                            hours > 0 && (React.createElement("span", { className: cn(styles.timeRemainingDesc, styles.p2) }, hours + " hour and ")),
                            mins > 0 && (React.createElement("span", { className: styles.timeRemainingDesc }, mins + " minutes remaining"))),
                        React.createElement(ProgressBar, { className: styles.progressIndicatorDesktop, durationM: durationM, viewingHistoryM: viewingHistoryM }))))))));
};
const BasicCardMobile = ({ id, isViewAll, linkHref, durationM, viewingHistoryM, railType, descriptionM, route, isContentAccessible, isNewEpisodeM, isPlayable, isPremium, image, kebabHandlerContinueWatch, showKebabMenu, name, read, removeFromfavorites, isSearchPage, category, userId, }) => {
    const ref = useRef(null);
    const [isIntersecting, setIntersecting] = useState(false);
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting));
    useEffect(() => {
        const refvalue = ref && ref.current;
        if (refvalue)
            observer.observe(refvalue);
        return () => {
            observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [kebabMenu, setKebMenu] = useState(false);
    const KebabMenuItems = [
        {
            label: Strings.REMOVE,
            name: name,
            description: descriptionM,
            route: route,
            id: id,
        },
        {
            label: Strings.SHARE,
            name: name,
            description: descriptionM,
            route: route,
            id: id,
        },
    ];
    const kebabMenuHandler = () => {
        setKebMenu(!kebabMenu);
    };
    const items = [
        {
            label: Strings.REMOVE_FROM_FAVOURITE,
            id: "UNLIKE",
        },
        {
            label: Strings.SHARE,
            id: "SHARE",
        },
    ];
    return (React.createElement("div", { className: styles.basicCardForMobile, id: `${id}` },
        React.createElement("div", { className: cn(styles.cardContainer, isViewAll ? styles.viewAllCardContainer : "", isSearchPage ? styles.searchCard : ""), id: "#" + id },
            React.createElement(ProgressBar, { className: styles.progressIndicator, durationM: durationM, viewingHistoryM: viewingHistoryM }),
            railType === RailTypes.DescriptiveWithProgress && (React.createElement(KebabMenuContinueWatch, { items: KebabMenuItems, kebabMenuItemHandlerCW: kebabHandlerContinueWatch, origin: "MOBILE" })),
            showKebabMenu && !isSearchPage && (React.createElement("div", { className: styles.moreIconWrapper, onClick: kebabMenuHandler },
                React.createElement(Icon, { type: Icons.More, className: styles.moreIcon, color: "#FFFFFF" }))),
            kebabMenu && showKebabMenu && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.kebabOverlay, onClick: () => setKebMenu(false) }),
                React.createElement("div", { className: styles.showKebabMenu },
                    React.createElement(KebabMenuForUnFavorites, { items: items, type: "show", read: read, removeFromfavorites: removeFromfavorites, closekebabMenu: kebabMenuHandler, id: id, route: route, name: name, descriptionM: descriptionM, image: image, category: category, userId: userId })))),
            React.createElement(Link, { href: linkHref },
                React.createElement("div", { ref: ref },
                    React.createElement(PlaceholderImage, null),
                    isIntersecting && image && (React.createElement(SonicImageDplus, { src: image.src, quality: 75, className: styles.railImages, width: 300 })))),
            isSearchPage && (React.createElement(Typography, { variant: HeaderVariants.headingSix, tag: Tags.h6, classNameM: M.of(styles.showNameForSearchLayout) },
                React.createElement(React.Fragment, null, name))),
            isContentAccessible && (React.createElement(Icon, { type: Icons.Plus18Tag, className: styles.ageConstraints })),
            isPremium && (React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: styles.premiumIcon })),
            React.createElement(RenderMaybe, null, M.map((isNewEpisode) => {
                return (React.createElement("div", { className: styles.newEpisodeContainer }, isNewEpisode && (React.createElement("span", { className: styles.Episodes }, "New Episodes"))));
            }, isNewEpisodeM)),
            isPlayable ? (React.createElement("div", { className: styles.PlayIcon },
                React.createElement(Icon, { type: Icons.PlayIcon, className: styles.playIcon }))) : (React.createElement(React.Fragment, null)))));
};

